import initContributorsGraphs from '~/contributors';

initContributorsGraphs();
